// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ai-media-result-container--kzoSw .ai-media-image-wrapper--qNh5w{aspect-ratio:16/9;overflow:hidden}.ai-media-result-container--kzoSw .ai-media-image--TFChQ{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ai-media-result-container": "ai-media-result-container--kzoSw",
	"ai-media-image-wrapper": "ai-media-image-wrapper--qNh5w",
	"ai-media-image": "ai-media-image--TFChQ"
};
export default ___CSS_LOADER_EXPORT___;
